import { z } from 'zod';
import { STORE_CODES } from '../enums.js';
/** Client-generated UUIDv4 (DATABASE §1). */
export const uuid = z.string().uuid();
/** ISO 8601 UTC (API §1). Kept as a string end-to-end; Postgres does the parsing. */
export const isoTimestamp = z
    .string()
    .datetime({ offset: true })
    .or(z.string().datetime())
    .describe('ISO 8601 timestamp');
export const storeCode = z.enum(STORE_CODES);
/** Money crosses the wire as integer cents, never a float or a formatted string. */
export const cents = z.number().int();
/** API §1.1 — the single error envelope every non-2xx response uses. */
export const errorBody = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
});
/**
 * Sync columns carried by every mutable, user-editable row (DATABASE §1).
 * Immutable event tables (purchases) do not carry these — they are append-only
 * and never conflict.
 */
export const syncColumns = z.object({
    created_at: isoTimestamp.optional(),
    updated_at: isoTimestamp,
    updated_by_user: uuid.nullish(),
    updated_by_device: z.string().nullish(),
    deleted_at: isoTimestamp.nullish(),
});
//# sourceMappingURL=common.js.map